import React, { useEffect, useState } from 'react';
import axios from '../../helpers/axios';
import { orderError } from '../../actions/api/order';
import OrderDialog from './OrderDialog';

export default function AddOrderProducts({ mutate, busy }) {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [show, setShow] = useState(false);
  const [query, setQuery] = useState('');
  const [ids, setIds] = useState([]);
  useEffect(() => {
    if (!show) return undefined;
    let active = true;
    setLoading(true); setError('');
    const timer = setTimeout(() => {
      axios.get('/admin/order-products', { params: { q: query } }).then(({ data }) => { if (active) setProducts(data.products || []); })
        .catch((cause) => { if (active) setError(orderError(cause)); })
        .finally(() => { if (active) setLoading(false); });
    }, 250);
    return () => { active = false; clearTimeout(timer); };
  }, [show, query]);
  const visible = products;
  return <><button type="button" className="orders-btn" disabled={busy} onClick={() => { setShow(true); setIds([]); setQuery(''); }}>Добавить товары</button>{show && <OrderDialog title="Добавить товары в заказ" onClose={() => setShow(false)} busy={busy} disabled={!ids.length || ids.length > 50} submitText={`Добавить${ids.length ? ` · ${ids.length}` : ''}`} onSubmit={() => mutate('addItems', { productIds: ids })}>
    <p className="orders-caption">Новые позиции добавятся без согласованной цены. Укажите её в карточке позиции, затем подтвердите итог заказа.</p>
    <label className="orders-field"><span>Поиск по каталогу</span><input value={query} onChange={(event) => setQuery(event.target.value)} placeholder="Название или артикул" /></label>
    {error && <p className="orders-warning" role="alert">{error}</p>}{loading && <p role="status">Поиск товаров…</p>}<div className="orders-product-picker">{visible.length ? visible.map((product) => <label key={product._id}><input type="checkbox" checked={ids.includes(product._id)} onChange={(event) => setIds((current) => event.target.checked ? [...current, product._id] : current.filter((id) => id !== product._id))} /><span>{product.fullName || product.name}{product.article != null && <small>Арт. {product.article}</small>}</span></label>) : <p>Товары не найдены.</p>}</div><p className="orders-caption">Показано до 100 результатов. Уточните название для поиска.</p>
  </OrderDialog>}</>;
}
